import makeStyles from '@mui/styles/makeStyles';
import { colors } from '@procore/core-react';

export const useStyles = makeStyles((theme) => ({
  header: {
    fontSize: '24px',
    letterSpacing: '0.15px',
    lineHeight: '32px',
    marginBottom: '8px',
    [theme.breakpoints.down(600)]: {
      fontSize: '20px',
      lineHeight: '28px',
    },
  },
  viewMoreButton: {
    fontSize: '14px',
    fontWeight: 400,
    textDecoration: 'underline',
    paddingTop: '12px',
    color: colors.black,
    '&:hover': {
      backgroundColor: 'transparent',
      textDecoration: 'underline',
    },
    '&:focus': {
      outline: 'none',
    },
    [theme.breakpoints.down(900)]: {
      paddingTop: '12px',
      paddingLeft: '0px',
    },
  },
  CollapsibleContentButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down(900)]: {
      justifyContent: 'start',
    },
  },
}));
